import {Card, CardHeader, Chip, Stack, Typography} from "@mui/material";
import {useEffect, useState} from "react";

const ChipsSelector = ({chips, title, subheader}) => {
    const [currentChips, setCurrentChips] = useState(chips);

    useEffect(() => {
        setCurrentChips([...chips]);
    }, [chips]);

    const handleClick = (id) => {
        const tempChips = [...currentChips];
        const cIndex = tempChips.findIndex(c => c.id === id);
        tempChips[cIndex].selected = !tempChips[cIndex].selected;

        setCurrentChips([...tempChips]);
    }

    const chipsList = currentChips.map(c => {
        return <Chip
            label={c.label}
            key={c.id}
            color={c.color ? c.color : 'primary'}
            variant={c.selected ? "" : "outlined"}
            onClick={() => handleClick(c.id)}
        />
    })

    return <>
        <Card variant='outlined'>
            <CardHeader
                title={title ? title : ''}
                subheader={subheader ? subheader : ''}
                titleTypographyProps={{variant: 'h6'}}
                subheaderTypographyProps={{variant: 'body1'}}
                />
            {chipsList.length > 0 && (
                <Stack
                    direction="row"
                    spacing={1}
                    flexWrap='wrap'
                    useFlexGap={true}
                    sx={{px: 2, pb: 2}}
                >
                {chipsList}
            </Stack>)}
            {chipsList.length === 0 && <Typography>Caricamento in corso</Typography>}
        </Card>
    </>
}

export default ChipsSelector;